import { Spin } from 'antd';
import appointmentApis from 'features/appointment/services/apis';
import appointmentSelectors from 'features/appointment/services/selectors';
import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import StaffListChooseUI from '../../QuickBooking/StaffListChooseUI';
type Props = {
  value?: IStaffItemData;
  onChange?: (value: IStaffItemData) => void;
  onPickStaff?: (value: IStaffItemData) => void;
  staffs?: IStaffItemData[];
};
const StaffChoose = ({ value, onChange = () => undefined, onPickStaff = () => undefined, staffs }: Props) => {
  const visibleAnybodyBooking = appointmentSelectors.visibleAnybodyBooking();
  const _onPickStaff = (value: IStaffItemData) => {
    onChange(value);
    onPickStaff(value);
  };
  return (
    <StaffListChooseUI staffs={staffs} anybody={visibleAnybodyBooking} onPickStaff={_onPickStaff} selectedStaffs={value ? [value?.id] : []} />
  );
};

export type StaffChooseV2Ref = {
  fetchStaffs: (date: string) => void;
};
export const StaffChooseV2 = forwardRef<StaffChooseV2Ref, Props>(({ value, onChange = () => undefined, onPickStaff = () => undefined, staffs: staffsProps }: Props, ref) => {
  const [loading, setLoading] = useState(false);
  const [_staffs, setStaffList] = useState<IStaffItemData[]>([]);
  const visibleAnybodyBooking = appointmentSelectors.visibleAnybodyBooking();
  const _onPickStaff = (value: IStaffItemData) => {
    onChange(value);
    onPickStaff(value);
  };

  const staffList = useMemo(() => {
    return staffsProps?.filter(o => {
      if (!o.anyBody && !_staffs.find(available => available.id?.toString() === o.id?.toString())) {
        return false;
      }
      return true;
    }) || [];
  }, [_staffs, staffsProps]);

  useImperativeHandle(ref, () => ({
    fetchStaffs: async (date: string) => {
      setLoading(true);
      try {
        const res = await appointmentApis.getListStaffAvailableBooking(date);
        if (res.data.data) {
          setStaffList(res.data.data);
        }
      } catch (error) {
        setStaffList([]);
      } finally {
        setLoading(false);
      }
    },
  }));
  return (
    <WrapperLoading>
      {!!loading && <div className="loading-container">
        <Spin size={'large'} />
      </div>}
      <StaffListChooseUI staffs={staffList} anybody={visibleAnybodyBooking} onPickStaff={_onPickStaff} selectedStaffs={value ? [value?.id] : []} />
    </WrapperLoading>
  );
});

StaffChooseV2.displayName = 'StaffChooseV2';
const WrapperLoading = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  .loading-container {
    position: absolute;
    inset: 0;
    overflow: auto;
    z-index: 99;
    background: rgba(255,255,255,0.25);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export default StaffChoose;
